"use client";

import { BSREyeClosed } from "./bsr/BSREyeClosed";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { EyeClosed as LegacyEyeClosed } from "./legacy/EyeClosed";

export const EyeClosed = createBSRExperimentIcon(LegacyEyeClosed, BSREyeClosed);
